export default {
    CARD: 'card'
};
